// Pre-login signal for "Staff Funnel: Bridge Link Opened" (#35459): the first observed attempt to
// open a comp-rater offer in Staff, whether or not the visitor is signed in. Runs once per page load,
// before ProtectedRoute's login redirect replaces the URL and the referrer, so in-app (router)
// navigation never reaches it. The endpoint decides from the offer itself whether the landing counts
// (an unmerged comp-rater offer) and answers the same empty 204 either way.
//
// Staff links that can open an offer in another tab carry ?entrySource=staff (staffOfferLink), and a
// Staff referrer is excluded, so internal tabs don't count. An empty referrer is unknown, not Staff:
// raters and Staff's own noreferrer links both produce one. ?rater=/?type= are informational only;
// many partners omit them.

export const STAFF_ENTRY_SOURCE = 'staff';

export const staffOfferLink = (offerId) => `/offer/${offerId}?entrySource=${STAFF_ENTRY_SOURCE}`;

const OFFER_LANDING_PATH = /^\/offer\/([^/]+)\/?$/;

// The Staff host itself, or one of its subdomains (e.g. the Descope auth.staff.* domain).
const isStaffHost = (host, staffHost) => host === staffHost || host.endsWith(`.${staffHost}`);

const hostnameOf = (url) => {
  try {
    return new URL(url).hostname.toLowerCase() || undefined;
  } catch {
    return undefined;
  }
};

export const getBridgeLanding = ({ location, referrer }) => {
  const offerId = location.pathname.match(OFFER_LANDING_PATH)?.[1];
  if (!offerId) {
    return null;
  }
  const params = new URLSearchParams(location.search);
  if (params.get('entrySource') === STAFF_ENTRY_SOURCE) {
    return null;
  }
  const referrerDomain = referrer ? hostnameOf(referrer) : undefined;
  if (referrerDomain && isStaffHost(referrerDomain, location.hostname.toLowerCase())) {
    return null;
  }
  return {
    offerId,
    rater: params.get('rater') || undefined,
    type: params.get('type') || undefined,
    referrerDomain
  };
};

// sendBeacon survives the login redirect's navigation without delaying it, and a plain-string
// body goes out as text/plain, so there is no CORS preflight.
export const sendBridgeLinkOpened = ({
  endpoint = import.meta.env.VITE_STAFF_BRIDGE_LINK_OPENED_URL,
  location = window.location,
  referrer = document.referrer,
  navigator = window.navigator
} = {}) => {
  if (!endpoint?.startsWith('https://') || typeof navigator?.sendBeacon !== 'function') {
    return;
  }
  const landing = getBridgeLanding({ location, referrer });
  if (landing) {
    navigator.sendBeacon(endpoint, JSON.stringify(landing));
  }
};
